import Vue from 'vue'

Vue.filter('dateTime', date => date ? new Date(date).toLocaleString(navigator.language) : '')

Vue.filter('date', date => date ? new Date(date).toLocaleDateString(navigator.language, {
  month: 'short',
  year: 'numeric',
  day: 'numeric',
}) : '')
